import { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import * as Sentry from '@sentry/browser';
import { useStores } from '../hooks/useStores';

const LiveAgentChat = () => {
  const { user } = useAuth0();
  const { storeInformation } = useStores();
  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      const helpButton = document?.querySelector('.embeddedServiceHelpButton');
      if (helpButton) {
        helpButton.style.visibility = 'visible';
        clearInterval(intervalRef.current);
      }
    }, 100);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  });

  useEffect(() => {
    const metadata = user?.[process.env.NEXT_PUBLIC_AUTH0_METADATA_CLAIM];
    const tenantId = user?.[process.env.NEXT_PUBLIC_AUTH0_TENANT_CLAIM];
    storeInformation
      .getSubscriptionStatus()
      .then(() => {
        const { subscription } = storeInformation;
        if (metadata && tenantId && window?.embedded_svc) {
          window.embedded_svc.settings.prepopulatedPrechatFields = {
            FirstName: metadata.firstname,
            LastName: metadata.lastname,
            Email: user.name,
            Subject: '',
          };
          window.embedded_svc.settings.extraPrechatFormDetails = [
            {
              label: 'Email',
              value: user.name,
              displayToAgent: false,
            },
            {
              label: 'Active Plan',
              value: subscription.plan.name,
              transcriptFields: ['Active_Plan__c'],
              displayToAgent: false,
            },
            {
              label: 'Customer Platform',
              value: 'V2',
              transcriptFields: ['Customer_Platform__c'],
              displayToAgent: false,
            },
            {
              label: 'Prime_Account_Checkbox_Test__c',
              value: subscription.plan.name.toLowerCase().indexOf('prime') > -1,
              transcriptFields: ['Prime_Account_Checkbox_Test__c'],
              displayToAgent: false,
            },
            {
              label: 'OrderDetails Name',
              value: subscription.id,
              displayToAgent: false,
            },
          ];
          window.embedded_svc.settings.extraPrechatInfo = [
            {
              entityName: 'OrderDetails__c',
              linkToEntityName: 'Case',
              linkToEntityField: 'Order_Detail_ID__c',
              showOnCreate: true,
              saveToTranscript: 'Order_Detail_ID__c',
              entityFieldMaps: [
                {
                  isExactMatch: true,
                  fieldName: 'Name',
                  doCreate: false,
                  doFind: true,
                  label: 'OrderDetails Name',
                },
              ],
            },
            {
              entityName: 'Contact',
              showOnCreate: true,
              linkToEntityName: 'Case',
              linkToEntityField: 'ContactId',
              saveToTranscript: 'Contact',
              entityFieldMaps: [
                {
                  isExactMatch: false,
                  fieldName: 'FirstName',
                  doCreate: false,
                  doFind: false,
                  label: 'First Name',
                },
                {
                  isExactMatch: false,
                  fieldName: 'LastName',
                  doCreate: false,
                  doFind: false,
                  label: 'Last Name',
                },
                {
                  isExactMatch: true,
                  fieldName: 'Email',
                  doCreate: true,
                  doFind: true,
                  label: 'Email',
                },
              ],
            },
          ];
        }
        return null;
      })
      .catch((error) => {
        Sentry.captureException(error);
      });
  }, [storeInformation, user]);

  return null;
};

const LiveAgentChatWrapper = () => {
  return <LiveAgentChat />;
};

export default LiveAgentChatWrapper;
